import { alpha } from '@mui/material'

const styles = {
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pt: 3,
    px: 2,
    pb: 5,
    position: 'fixed',
    top: 0,
    zIndex: 2,
    backgroundColor: 'neutral.white',
  },
  isFiltersHeader: {
    background: theme =>
      `linear-gradient(${theme.palette.neutral.white} 50%, ${alpha(
        theme.palette.neutral.white,
        0,
      )} 100%)`,
  },
  closeButton: { color: 'neutral.main' },
  isFullHeightContent: { height: '100vh' },
  innerContent: { pt: 12 },
}

export default styles
